import useLocale from 'common/hooks/useLocale';
import MainLayoutDesktop from 'components/scaffold/MainLayoutDesktop';
import React from 'react';
import InfoScreenDesktop from './InfoScreenDesktop';
import Privacy from './Privacy';
import { PrivacyScreenViewProps } from './PrivacyScreenViewProps';

export default function PrivacyDesktop(props: PrivacyScreenViewProps) {
  const { layoutProps, privacyProps, onBackClick } = props;

  const { langSetting } = useLocale();

  return <MainLayoutDesktop {...layoutProps}>
    <InfoScreenDesktop title={langSetting.captionPrivacy}
      children={{
        privacy: <Privacy 
          items={privacyProps}
          noShadow={true}
        />
      }}
      onBackClick={onBackClick}
    />
  </MainLayoutDesktop>
}